var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"man_list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"info_img"},[_c('img',{attrs:{"src":item?item:'../../../../public/img/orderInfo2/mr.png'}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }